import { Button, Drawer } from 'antd'
import { MenuOutlined, ArrowRightOutlined, InstagramOutlined, MailOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import BrandLogo from './BrandLogo'
import type { Locale } from '../hooks/useLocale'

type Props = { locale: Locale; setLocale: (v: Locale) => void; copy: any }

export default function Navbar({ locale, setLocale, copy }: Props) {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    setOpen(false)
  }

  return (
    <>
      <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
        <div className="nav__inner container">
          <button className="logoButton" onClick={() => go('top')} aria-label="Go to top">
            <BrandLogo />
          </button>

          <nav className="nav__links" aria-label="Main Navigation">
            <button onClick={() => go('services')}>{copy.nav.services}</button>
            <button onClick={() => go('approach')}>{copy.nav.approach}</button>
            <button onClick={() => go('who-we-serve')}>{copy.nav.whoWeServe}</button>
            <button onClick={() => go('contact')}>{copy.nav.contact}</button>
          </nav>

          <div className="nav__actions">
            <div className="nav__socials" aria-label="TALENXA social links">
              <a href="https://www.instagram.com/talenxard" target="_blank" rel="noopener noreferrer" className="socialBtn" aria-label="Instagram">
                <InstagramOutlined />
              </a>
              <a href="mailto:hello@talenxa.com.do" className="socialBtn" aria-label="Email TALENXA">
                <MailOutlined />
              </a>
            </div>
            <button
              className="lang"
              onClick={() => setLocale(locale === 'es' ? 'en' : 'es')}
              aria-label="Toggle language"
            >
              <span className={locale === 'es' ? 'lang--active' : ''}>ES</span>
              <span className="lang__sep">/</span>
              <span className={locale === 'en' ? 'lang--active' : ''}>EN</span>
            </button>

            <Button className="navCta goldBtn" type="primary" onClick={() => go('contact')}>
              {copy.nav.cta} <ArrowRightOutlined />
            </Button>
          </div>

          <Button
            className="mobileMenu"
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          />
        </div>
      </header>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        title={<BrandLogo light />}
        placement="right"
        className="navDrawer"
        rootClassName="navDrawer"
      >
        <div className="drawerContent">
          <div className="drawerLinks">
            <button type="button" onClick={() => go('services')}>{copy.nav.services}</button>
            <button type="button" onClick={() => go('approach')}>{copy.nav.approach}</button>
            <button type="button" onClick={() => go('who-we-serve')}>{copy.nav.whoWeServe}</button>
            <button type="button" onClick={() => go('contact')}>{copy.nav.contact}</button>
          </div>

          <div className="drawerFooter">
            <div className="drawerSocials" aria-label="TALENXA social links">
              <a href="https://www.instagram.com/talenxard" target="_blank" rel="noopener noreferrer" className="socialBtn socialBtn--light" aria-label="Instagram">
                <InstagramOutlined />
              </a>
              <a href="mailto:hello@talenxa.com.do" className="socialBtn socialBtn--light" aria-label="Email TALENXA">
                <MailOutlined />
              </a>
            </div>
            <button
              className="drawerLang"
              onClick={() => setLocale(locale === 'es' ? 'en' : 'es')}
            >
              🌐 {locale === 'es' ? 'Switch to English' : 'Cambiar a Español'}
            </button>
          </div>
        </div>
      </Drawer>
    </>
  )
}
